import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TabContainer from "@mui/material/TableContainer";
import ApiUserManager from "../../../core/api/api.userManager";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiRoleManager from "../../../core/api/api.roleManager";
import { numberRegex } from "../../../core/utils/tools"

const AddEditeModal = ({ showModalUser, setShowModalUser, selectedUserId }) => {
  const [tabValue, setTabValue] = React.useState(0);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({
    defaultValues: { roleList: [], id: 0 },
  });
  const [roleslist, setRolesList] = useState([]);
  const handleClose = () => {
    setShowModalUser(false);
  };
  useEffect(() => {
    (async () => {
      try {
        setValue("roles.Admin", true);
        // دریافت نقش های موجود برای ادمین
        const rolesData = await ApiRoleManager.getAllAdminRoles({ pageSize: 100, pageNumber: 1 });
        setRolesList(rolesData.data);

        if (selectedUserId != 0) {
          // دریافت اطلاعات کاربر جهت ویرایش
          let response = await ApiUserManager.getUserById({ id: selectedUserId });
          if (response.succeeded == true) {
            setValue("id", response.data.id);
            setValue("firstName", response.data.firstName);
            setValue("lastName", response.data.lastName);
            setValue("email", response.data.email);
            setValue("phoneNumber", response.data.phoneNumber);
            setValue("userName", response.data.userName);
            //setValue("roleList", response.data.roleList);
            rolesData.data.forEach((item) => {
              if (response.data.roleList.findIndex((e) => e == item.persianName) != -1)
                setValue("roles." + item.name, true);
              else setValue("roles." + item.name, false);
            });
            setValue("roles.Admin", true);
          }
        }
      } catch (error) {
      }
    })();

    return () => { };
  }, []);

  function handleChange(event, newValue) {
    setTabValue(newValue);
  }

  const onSubmit = async (data) => {
    try {
      // ساخت لیست نقش های انتخابی برای این کاربر
      let roleList = [];
      if (_.isEmpty(data.roles)) roleList.push("Admin");
      else {
        Object.entries(data.roles).map(([key, value]) => {
          if ((value != undefined && value == true) || key == "Admin") roleList.push(key);
        });
      }
      data.roleList = roleList;


      let response = null;
      if (data.id <= 0) response = await ApiUserManager.createUsers(data);
      else response = await ApiUserManager.updateUser(data);

      if (response.succeeded == true) document.getElementById("submitButton").click();


      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="md" show={setShowModalUser} onHide={handleClose}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>{selectedUserId ? "ویرایش کاربر" : "افزودن کاربر جدید"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Paper className="tab-noStyle">
              <Tabs value={tabValue} onChange={handleChange} indicatorColor="primary" textColor="primary">
                <Tab label="اطلاعات کاربر" />
                <Tab label="مجوزها" />
              </Tabs>
            </Paper>
            {tabValue === 0 && (
              <TabContainer className=" border border-top-0 py-3 border-bottom-radius">
                <Col xs="12">
                  <Row>
                    <Col xs="12">
                      <Controller
                        name="firstName"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                      {errors.firstName && <span>لطفا نام را وارد نمایید</span>}
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="lastName"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام خانوادگی"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                      {errors.lastName && <span>لطفا نام خانوادگی را وارد نمایید</span>}
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="email"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="ایمیل"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                      {errors.email && <span>لطفا ایمیل را وارد نمایید</span>}
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="phoneNumber"
                        rules={{ required: true }}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="شماره تلفن همراه"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={(e) => {
                              if (e.target.value && (!numberRegex.test(e.target.value) || e.target.value.length > 11)) {
                                e.target.value = getValues("phoneNumber")
                                return
                              }
                              onChange(e)
                            }}
                          />
                        )}
                      />
                      {errors.phoneNumber && <span>لطفا تلفن همراه را وارد نمایید</span>}
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="userName"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام کاربری"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                      {errors.userName && <span>لطفا نام کاربری را وارد نمایید</span>}
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="password"
                        control={control}
                        // rules={{ required: true, }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="رمز عبور"
                            margin="normal"
                            variant="outlined"
                            type="password"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                      {/* {errors.password && <span>لطفا رمز عبور را وارد نمایید</span>} */}
                    </Col>
                  </Row>
                </Col>
              </TabContainer>
            )}
            {tabValue === 1 && (
              <TabContainer className=" border border-top-0 py-3 border-bottom-radius">
                <Col xs="12">
                  <FormGroup>
                    {roleslist?.map((itemData, index) => (
                      <FormControlLabel
                        key={index}
                        control={
                          <Controller
                            control={control}
                            name={"roles." + itemData.name}
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                              fieldState: { invalid, isTouched, isDirty, error },
                            }) => (
                              <Checkbox
                                key={index}
                                color="primary"
                                disabled={itemData.name == "Admin" ?? true}
                                onBlur={onBlur}
                                onChange={onChange}
                                checked={value || false}
                                //checked={itemData.name == "Admin" ? true : (value || false)}
                                //checked={itemData.name == "Admin" ? true : (value || ((roleslistUpdateUser.findIndex(e => e == itemData.persianName) != -1) ?  (value || false) :  (value || true) ))}
                                //checked={IsRoleCheck(itemData)}
                                inputRef={ref}
                              />
                            )}
                          />
                        }
                        label={itemData.persianName}
                      />
                    ))}
                  </FormGroup>
                </Col>
              </TabContainer>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
export default AddEditeModal;
